<template>
  <div class="login">
    <div class="login-bgc-top">
      <img src="@/assets/image/login/bgc-top-r.png" />
    </div>

    <div class="FormSubmit">
      <van-form ref="form" @submit="onSubmit">
        <!--           type="tel" -->
        <van-field
          class="iconfont icon-shoujihao1"
          v-model="tel"
          clearable
          name="tel"
          :rules="userTel"
          placeholder="请输入姓名"
        />
        <van-field
          class="iconfont icon-shoujihao1"
          v-model="pass"
          type="password"
          clearable
          name="tel"
          :rules="mima"
          placeholder="请输入密码"
        />
        <van-field
          class="iconfont icon-shoujihao1"
          v-model="confirm_pwd"
          type="password"
          clearable
          name="tel"
          :rules="querenmima"
          placeholder="请再次输入密码"
        />
        <van-field
          v-model="sms"
          center
          ref="yanzhengCode"
          :rules="userMsg"
          clearable
          class="iconfont icon-yanzhengyanzhengma"
          placeholder="请输入手机验证码"
          maxlength="6"
        >
          <!-- type="digit" -->
          <template #button>
            <!-- <van-button
              type="primary"
              size="small"
              class="getCode"
              @click="sendCode"
              :disabled="ifdisabled"
              native-type="button"
            >
              {{ codeMsg }}
            </van-button> -->
            <drawCode :imgurl="imgurl" @getCodeFn="getCodeFn" />
          </template>
        </van-field>
        <div class="login-btn">
          <van-button block type="primary" native-type="submit"
            ><span style="fontsize: px">注&nbsp;册</span>
          </van-button>
        </div>
        <div class="text-box">
          <div class="text-box-no">已有帐号，</div>
          <div class="text-box-go" @click="$router.push('login')">去登录</div>
        </div>
      </van-form>
    </div>

    <!-- <div class="login-bgc-bottom">
      <img src="@/assets/image/login/bgc-bottom.png">
    </div> -->
  </div>
</template>

<script>
import drawCode from "../../components/drawCode/index.vue";
export default {
  name: "login",
  components: {
    drawCode,
  },
  data() {
    return {
      pass: "",
      confirm_pwd: "",
      tel: "",
      sms: "",
      uniqid: "",
      imgurl: "",
      identity: "1",
      ifdisabled: false,
      codeNum: 60,
      codeMsg: "获取验证码",
      count: "",
      userTel: [
        {
          required: true,
          message: "请输入姓名",
          trigger: "onChange",
        },
        // {
        //   validator: (value) => {
        //     return /^1[23456789]\d{9}$/.test(value);
        //   },
        //   message: "手机号格式错误，请检查！",
        // },
      ],
      mima: [
        {
          required: true,
          message: "请输入密码",
          trigger: "onChange",
        },
      ],
      querenmima: [
        {
          required: true,
          message: "请再次输入密码",
          trigger: "onChange",
        },
        {
          validator: (value) => {
            return value == this.pass;
          },
          message: "两次密码不一致",
        },
      ],
      userMsg: [
        {
          required: true,
          message: "请输入验证码",
          trigger: "onChange",
        },
        // {
        //   validator: (value) => {
        //     // return /^\d{6}$/.test(value);
        //   },
        //   message: "验证码格式错误，请检查！",
        // },
      ],
    };
  },
  created() {
    this.getCodeFn();
  },
  methods: {
    // 获取短信验证码
    async sendCode() {
      // 验证手机号格式是否正确
      if (!this.tel) {
        this.$toast("请输入手机号！");
        return;
      }
      if (!this.userTel[1].validator(this.tel)) return;
      //发送请求
      const { data: data } = await this.$http.post("system/sms", {
        phone: this.tel,
        type: " REG",
      });
      if (data.code === 200) {
        this.$toast("验证码已发送！");
        // 禁用按钮
        this.ifdisabled = true;
        // 倒计时
        this.count = this.codeNum;
        let timer = setInterval(() => {
          if (this.count > 1 && this.count <= this.codeNum) {
            this.count--;
            this.codeMsg = `重新发送(${this.count})`;
          } else {
            // 判断什么时候停止定时器
            clearInterval(timer);
            this.codeMsg = "获取验证码";
            this.ifdisabled = false;
            this.count = "";
          }
        }, 1000);
      } else {
        this.$toast(data.message);
      }
    },
    //注册
    async onSubmit() {
      const { data: data } = await this.$http.post("auth/register", {
        userTypeId: "1",
        username: this.tel,
        password: this.pass,
        confirm_pwd: this.confirm_pwd,
        code: this.sms,
        uniqid: this.uniqid,
      });
      if (data.code == 200) {
        localStorage.setItem("token", data.data.access_token);
        // this.getMeApi();
        this.$router.push("/homeTopic");
      }
    },
    //获取用户信息 判断是否认证
    async getMeApi() {
      const { data: data } = await this.$http.post("auth/me");
      localStorage.setItem("information", JSON.stringify(data.data));
      if (data.data.doctor_status == 0) {
        this.$router.push("certification");
      } else {
        this.$toast(data.message);
        this.$router.push("/homeTopic");
      }
    },
    async getCodeFn() {
      let { data: res } = await this.$http.get("auth/captcha");
      if (res.code === 200) {
        this.imgurl = res.data.image;
        this.uniqid = res.data.uniqid;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.login {
  height: 100vh;
  position: relative;
  overflow: hidden;

  .login-bgc-top {
    position: relative;
    top: 0;
    left: 0;
    width: 306px;
    height: 241px;
  }

  .van-field__control {
    font-size: 16px;
    margin-left: 15px;
  }
  .situLogo {
    margin: 40px auto;
    width: 218px;
    height: 108px;
  }
  .getCode {
    // border-radius: 10px;
    background-color: #ea260e;
    border: 0.02667rem solid #ea260e;
    background: linear-gradient(90deg, #ea260e 0%, #f86b05 100%) !important;
  }
  .FormSubmit {
    margin-top: 10px;
  }
  .login-btn {
    margin-top: 50px;
    padding: 0 30px;
    /deep/ .van-button--primary {
      background-color: #04b5c4;
      border: 0.02667rem solid #04b5c4;
      background: #04b5c4 !important;
    }
  }

  .footCar {
    position: fixed;
    bottom: 0px;
    right: 0px;
  }

  .text-box {
    display: flex;
    padding: 0 30px;
    justify-content: flex-end;
    margin-top: 13px;
    font-size: 13px;
    .text-box-go {
      color: #ef3f0b;
    }
    .text-box-no {
      color: #333;
    }
  }

  .login-bgc-bottom {
    position: absolute;
    bottom: -4px;
    right: 0;
    width: 100%;
    // height: 109px;
  }
}
</style>
